import service from 'utils/http.js'
import config from 'config'
const { JOJOREAD_API } = config

//  协议上报
export async function commonIpUaReport(params, headers) {
  let res = await service.post(`/api/nuwa/commonIpUaReport`, params, {
    baseURL: JOJOREAD_API,
    headers
  })
  return res
}

/**
 * 预览接口
 * @param {Object} params { agreementId: 协议id, id: 版本id}
 * @returns
 */
export async function preview(params) {
  let res = await service.get(`/api/nuwa/userAgreement/preview`, {
    // baseURL: JOJOREAD_API,
    // baseURL: 'http://api.dev.tinman.cn',
    params
  })
  return res
}

/**
 * 隐私协议
 * @param {Object} params { agreementKey: 协议key, platform: 平台 }
 * @param {Object} headers
 * @returns
 */
export async function getPrivacyAgreement(params, headers) {
  let res = await service.get(`/api/nuwa/userAgreement/matchVersion`, {
    // baseURL: JOJOREAD_API,
    headers,
    params
  })
  return res
}
